import { differenceInDays } from 'src/app/shared/utils/dates';

import type { StarterDashboardRootPageDataQuery } from '../rootPageData.graphql';

type Petition = NonNullable<StarterDashboardRootPageDataQuery['petition']>;
export function getPetitionDaysAfterPublish(petition: Petition) {
	const now = new Date();

	return differenceInDays(now, new Date(petition.publishedAt ?? 0));
}
